import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Translator from '../Translator';

export const Program = () => {
    const params = useParams();
    const [data, setData] = useState('');

    const loadProgram = async (program) => {
        const code = await import('../../lib/programs/'+program+'.js')
        setData(code.default);
    }

    useEffect(() => {
        if (params.slug)
            loadProgram(params.slug)
    }, [params]);

    return (
     <>
        {data ? <Translator defaultMachine={'haas-st-2026'} program={data} /> : ''}
     </>
    );
};

export default Program;